import {
  MapPin,
  Phone,
  Mail,
  Calendar,
  ChevronDown,
  ChevronUp,
  MessageSquare,
  CheckCircle2,
  Lock,
  Send,
  Target,
  Award,
  FileText,
  TrendingUp,
  Edit3,
  Save,
  User,
} from "lucide-react"
import { useState, useEffect } from "react"
import { useAuth } from "../context/AuthContext"
import { db } from "../components/Authenticator/firebase"
import { collection, doc, getDoc, setDoc, getDocs } from "firebase/firestore"
import "../styles/customer-cards.css"

// Datos mock - se reemplazarán con datos de Firestore
const mockData = [
  {
    nombre_cliente: "Agricultura del Ebro S.A.",
    codigo_cliente: "CLI-001",
    tipo_cliente: "Premium",
    poblacion: "Zaragoza",
    provincia: "Zaragoza",
    telefono: "+34 976 123 456",
    email: "contacto@agroebre.es",
    bandejas_2020: 1200,
    bandejas_2021: 1350,
    bandejas_2022: 1400,
    bandejas_2023: 1450,
    bandejas_2024: 1500,
    promedio_2020_2024: 1380,
    bandejas_2025: 950,
    bandejas_perdidas: 550,
    porcentaje_caida: 36.67,
    clasificacion_riesgo: "Alta",
    isNew: true,
    etapas: [
      {
        id: "1",
        nombre: "Primera Instancia",
        tipo: "Indirecto",
        emailEnviado: false,
        telefonoEnviado: false,
        calidadEnviada: false,
        certificacionesEnviadas: false,
        avancesEnviados: false,
        fechaRealizado: "",
        descripcion: "",
        fechaCreacion: "2025-02-10",
        retornoDetectado: false,
      },
      {
        id: "2",
        nombre: "Contacto Directo",
        tipo: "Directo",
        emailEnviado: false,
        telefonoEnviado: false,
        whatsappEnviado: false,
        fechaRealizado: "",
        descripcion: "",
        fechaCreacion: "2025-02-18",
        retornoDetectado: false,
      },
    ],
  },
  {
    nombre_cliente: "Ganadería Los Robles",
    codigo_cliente: "CLI-002",
    tipo_cliente: "Estándar",
    poblacion: "Teruel",
    provincia: "Teruel",
    telefono: "+34 978 234 567",
    email: "info@losrobles.com",
    bandejas_2020: 800,
    bandejas_2021: 850,
    bandejas_2022: 900,
    bandejas_2023: 920,
    bandejas_2024: 940,
    promedio_2020_2024: 882,
    bandejas_2025: 820,
    bandejas_perdidas: 120,
    porcentaje_caida: 12.77,
    clasificacion_riesgo: "Media",
    etapas: [
      {
        id: "1",
        nombre: "Primera Instancia",
        tipo: "Indirecto",
        emailEnviado: false,
        telefonoEnviado: false,
        calidadEnviada: false,
        certificacionesEnviadas: false,
        avancesEnviados: false,
        fechaRealizado: "",
        descripcion: "",
        fechaCreacion: "2025-02-18",
        retornoDetectado: false,
      },
      {
        id: "2",
        nombre: "Contacto Directo",
        tipo: "Directo",
        emailEnviado: false,
        telefonoEnviado: false,
        whatsappEnviado: false,
        fechaRealizado: "",
        descripcion: "",
        fechaCreacion: "2025-02-18",
        retornoDetectado: false,
      },
    ],
  },
  {
    nombre_cliente: "Cooperativa Agrícola del Sur",
    codigo_cliente: "CLI-003",
    tipo_cliente: "Premium",
    poblacion: "Huesca",
    provincia: "Huesca",
    telefono: "+34 974 345 678",
    email: "administracion@coopsur.es",
    bandejas_2020: 2100,
    bandejas_2021: 2200,
    bandejas_2022: 2250,
    bandejas_2023: 2300,
    bandejas_2024: 2350,
    promedio_2020_2024: 2240,
    bandejas_2025: 2280,
    bandejas_perdidas: 70,
    porcentaje_caida: 2.98,
    clasificacion_riesgo: "Baja",
    isNew: true,
    etapas: [
      {
        id: "1",
        nombre: "Primera Instancia",
        tipo: "Indirecto",
        emailEnviado: false,
        telefonoEnviado: false,
        calidadEnviada: false,
        certificacionesEnviadas: false,
        avancesEnviados: false,
        fechaRealizado: "",
        descripcion: "",
        fechaCreacion: "2025-02-20",
        retornoDetectado: false,
      },
      {
        id: "2",
        nombre: "Contacto Directo",
        tipo: "Directo",
        emailEnviado: false,
        telefonoEnviado: false,
        whatsappEnviado: false,
        fechaRealizado: "",
        descripcion: "",
        fechaCreacion: "2025-02-20",
        retornoDetectado: false,
      },
    ],
  },
]

export default function CustomerCards() {
  const { user } = useAuth()
  const [expandedCards, setExpandedCards] = useState({})
  const [stageData, setStageData] = useState({})
  const [customers, setCustomers] = useState([])
  const [loading, setLoading] = useState(true)

  const toggleCard = (codigo) => {
    setExpandedCards((prev) => ({
      ...prev,
      [codigo]: !prev[codigo],
    }))
  }

  // Cambiar checkbox y guardar en Firestore
  // IMPORTANTE: Solo guarda en la colección "recuperacion-clientes", NO toca otras colecciones
  const handleCheckboxChange = async (cardId, stageId, field, originalStage, customerId) => {
    const currentData = stageData[cardId]?.[stageId] || originalStage
    const newValue = !currentData[field]
    
    // Actualizar estado local primero
    setStageData((prev) => {
      return {
        ...prev,
        [cardId]: {
          ...prev[cardId],
          [stageId]: {
            ...currentData,
            [field]: newValue,
          },
        },
      }
    })

    // Preparar datos actualizados para Firestore
    const updatedData = {
      ...currentData,
      [field]: newValue,
    }
    
    // Usar customerId (ID del documento en Firestore) si está disponible
    const idToUse = customerId || cardId
    
    // Guardar en Firestore - SOLO en la colección "recuperacion-clientes"
    const saved = await saveStageToFirestore(idToUse, stageId, updatedData)
    
    if (!saved) {
      console.warn("⚠️ No se pudo guardar checkbox en Firestore, pero el cambio está en el estado local")
    }
  }

  const handleInputChange = (
    cardId,
    stageId,
    field,
    value,
    originalStage,
  ) => {
    setStageData((prev) => {
      const currentData = prev[cardId]?.[stageId] || originalStage
      return {
        ...prev,
        [cardId]: {
          ...prev[cardId],
          [stageId]: {
            ...currentData,
            [field]: value,
          },
        },
      }
    })
  }

  const toggleEditMode = (cardId, stageId, originalStage) => {
    setStageData((prev) => {
      const currentData = prev[cardId]?.[stageId] || originalStage
      const isCurrentlyEditing = currentData.isEditing
      
      // Si se está iniciando la edición y no hay usuario, agregarlo automáticamente
      const updatedData = { ...currentData, isEditing: !isCurrentlyEditing }
      if (!isCurrentlyEditing && !updatedData.usuario) {
        updatedData.usuario = getUserName()
      }
      
      return {
        ...prev,
        [cardId]: {
          ...prev[cardId],
          [stageId]: updatedData,
        },
      }
    })
  }

  const isFirstStageCompleted = (cardId, firstStageId, originalStage) => {
    const data = stageData[cardId]?.[firstStageId] || originalStage
    return data.emailEnviado || data.telefonoEnviado
  }

  const getStageData = (cardId, stageId, originalStage) => {
    return stageData[cardId]?.[stageId] || originalStage
  }

  // Obtener nombre del usuario
  const getUserName = () => {
    if (!user?.displayName) return ""
    return user.displayName
  }

  // Cargar datos de Firestore
  // IMPORTANTE: Solo lee de la colección "recuperacion-clientes", NO toca otras colecciones
  const loadCustomers = async () => {
    try {
      console.log("🔄 [CustomerCards] Iniciando carga de clientes desde Firestore...")
      setLoading(true)
      // COLECCIÓN COMPLETAMENTE SEPARADA - NO afecta chats, deitana-conversaciones, etc.
      const recuperacionRef = collection(db, "recuperacion-clientes")
      console.log("📊 [CustomerCards] Consultando Firestore colección: recuperacion-clientes")
      const snapshot = await getDocs(recuperacionRef)
      
      console.log(`📊 [CustomerCards] Snapshot recibido. Empty: ${snapshot.empty}, Size: ${snapshot.size}`)
      
      if (snapshot.empty) {
        console.warn("⚠️ [CustomerCards] No hay datos en 'recuperacion-clientes', usando datos mock temporalmente")
        // Si no hay datos, usar mockData temporalmente
        setCustomers(mockData)
        setLoading(false)
        return
      }

      const customersData = []
      snapshot.forEach((docSnap) => {
        const data = docSnap.data()
        console.log(`📄 [CustomerCards] Procesando cliente: ${docSnap.id} - ${data.nombre_cliente || 'Sin nombre'}`)
        customersData.push({
          id: docSnap.id, // ID del documento en Firestore (importante para guardar)
          ...data,
          // Asegurar que las etapas existan
          etapas: data.etapas || []
        })
      })
      
      console.log(`✅ [CustomerCards] Cargados ${customersData.length} clientes desde Firestore (colección: recuperacion-clientes)`)
      console.log(`📋 [CustomerCards] Primer cliente de ejemplo:`, customersData[0]?.nombre_cliente || 'N/A')
      setCustomers(customersData)
    } catch (error) {
      console.error("❌ [CustomerCards] Error cargando clientes desde Firestore:", error)
      console.error("❌ [CustomerCards] Stack trace:", error.stack)
      // En caso de error, usar mockData para no romper la UI
      setCustomers(mockData)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    console.log("🔍 [CustomerCards] useEffect ejecutado. User:", user ? user.uid : "No autenticado")
    if (user) {
      console.log("✅ [CustomerCards] Usuario autenticado, cargando clientes...")
      loadCustomers()
    } else {
      console.warn("⚠️ [CustomerCards] Usuario no autenticado, esperando...")
    }
  }, [user])

  // Guardar etapa en Firestore - COLECCIÓN COMPLETAMENTE SEPARADA: "recuperacion-clientes"
  // Esta colección NO toca ninguna otra colección existente (chats, deitana-conversaciones, etc.)
  const saveStageToFirestore = async (customerId, stageId, stageData) => {
    try {
      const customerRef = doc(db, "recuperacion-clientes", customerId)
      const customerDoc = await getDoc(customerRef)
      
      if (!customerDoc.exists()) {
        console.error("⚠️ Cliente no encontrado en Firestore:", customerId)
        return false
      }

      const customerData = customerDoc.data()
      const now = new Date()
      const userName = getUserName()
      
      // Actualizar la etapa específica con información de auditoría
      const updatedEtapas = customerData.etapas.map(etapa => {
        if (etapa.id === stageId) {
          return {
            ...etapa,
            ...stageData,
            // Información de auditoría
            ultimaModificacion: now.toISOString(),
            usuarioModificacion: userName || user?.email || "Usuario desconocido",
            // Mantener fechaCreacion si existe
            fechaCreacion: etapa.fechaCreacion || now.toISOString(),
          }
        }
        return etapa
      })

      // Guardar con merge para no sobrescribir otros campos
      await setDoc(customerRef, {
        ...customerData,
        etapas: updatedEtapas,
        ultimaActualizacion: now.toISOString(),
        usuarioUltimaActualizacion: userName || user?.email || "Usuario desconocido",
      }, { merge: true })
      
      console.log("✅ Etapa guardada correctamente en Firestore:", {
        customerId,
        stageId,
        usuario: userName,
        timestamp: now.toISOString()
      })
      
      return true
    } catch (error) {
      console.error("❌ Error guardando etapa en Firestore:", error)
      return false
    }
  }

  // Modificar handleInputChange para guardar en Firestore
  // IMPORTANTE: Solo guarda en la colección "recuperacion-clientes", NO toca otras colecciones
  const handleInputChangeWithSave = async (
    cardId,
    stageId,
    field,
    value,
    originalStage,
    customerId,
  ) => {
    // Actualizar estado local primero
    handleInputChange(cardId, stageId, field, value, originalStage)
    
    // Obtener datos actuales
    const currentData = stageData[cardId]?.[stageId] || originalStage
    const updatedData = {
      ...currentData,
      [field]: value,
    }
    
    // Si el campo es descripcion y se está editando, agregar usuario automáticamente si no existe
    if (field === "descripcion" && value && !updatedData.usuario) {
      updatedData.usuario = getUserName()
    }
    
    // Usar customerId (ID del documento en Firestore) si está disponible, sino usar cardId
    const idToUse = customerId || cardId
    
    // Guardar en Firestore - SOLO en la colección "recuperacion-clientes"
    const saved = await saveStageToFirestore(idToUse, stageId, updatedData)
    
    if (!saved) {
      console.warn("⚠️ No se pudo guardar en Firestore, pero los cambios están en el estado local")
    }
  }

  // Modificar toggleEditMode para guardar cuando se guarda
  // IMPORTANTE: Solo guarda en la colección "recuperacion-clientes", NO toca otras colecciones
  const toggleEditModeWithSave = async (cardId, stageId, originalStage, customerId) => {
    const currentData = stageData[cardId]?.[stageId] || originalStage
    const isEditing = currentData.isEditing

    // Primero cambiar el modo de edición
    toggleEditMode(cardId, stageId, originalStage)

    if (isEditing) {
      // Al guardar (salir del modo edición), persistir en Firestore
      // Usar customerId (ID del documento en Firestore) si está disponible, sino usar cardId
      const idToUse = customerId || cardId
      
      // Obtener los datos actualizados después de toggleEditMode
      const updatedData = stageData[cardId]?.[stageId] || currentData
      
      // Asegurar que el usuario esté guardado si no existe
      if (!updatedData.usuario && updatedData.descripcion) {
        updatedData.usuario = getUserName()
      }
      
      const saved = await saveStageToFirestore(idToUse, stageId, updatedData)
      
      if (!saved) {
        console.warn("⚠️ No se pudo guardar al salir del modo edición, pero los cambios están en el estado local")
      } else {
        console.log("✅ Cambios guardados correctamente al salir del modo edición")
      }
    }
  }

  if (loading) {
    return (
      <div className="customer-cards-container">
        <div style={{ textAlign: 'center', padding: '2rem', color: '#6b7280' }}>
          Cargando clientes...
        </div>
      </div>
    )
  }

  const customersToDisplay = customers.length > 0 ? customers : mockData
  
  console.log("🎯 [CustomerCards] Render - customers.length:", customers.length)
  console.log("🎯 [CustomerCards] Render - customersToDisplay.length:", customersToDisplay.length)
  console.log("🎯 [CustomerCards] Render - Primer cliente a mostrar:", customersToDisplay[0]?.nombre_cliente || 'N/A')
  console.log("🎯 [CustomerCards] Render - Usando datos:", customers.length > 0 ? "REALES" : "MOCK")

  return (
    <div className="customer-cards-container">
      <div className="cards-grid">
        {customersToDisplay.map((customer, index) => (
          <div key={index} className="customer-card">
            <div className="card-header">
              <h3 className="card-title">{customer.nombre_cliente}</h3>
              <div className="card-meta">
                <span className="card-code">{customer.codigo_cliente}</span>
                <span className="badge badge-type">{customer.tipo_cliente}</span>
                {customer.isNew && <span className="badge badge-new">NUEVO</span>}
              </div>
            </div>

            <div className="card-info">
              <div className="info-row">
                <MapPin className="info-icon" size={16} />
                <span className="info-text">
                  {customer.poblacion}, {customer.provincia}
                </span>
              </div>
              <div className="info-row">
                <Phone className="info-icon" size={16} />
                <span className="info-text">{customer.telefono}</span>
              </div>
              <div className="info-row">
                <Mail className="info-icon" size={16} />
                <span className="info-text">{customer.email}</span>
              </div>
            </div>

            <div className="data-section">
              <div className="section-header">
                <Calendar size={14} />
                <span>Histórico de Bandejas</span>
              </div>
              <div className="data-grid">
                <div className="data-item">
                  <div className="data-label">2020</div>
                  <div className="data-value">{customer.bandejas_2020}</div>
                </div>
                <div className="data-item">
                  <div className="data-label">2021</div>
                  <div className="data-value">{customer.bandejas_2021}</div>
                </div>
                <div className="data-item">
                  <div className="data-label">2022</div>
                  <div className="data-value">{customer.bandejas_2022}</div>
                </div>
                <div className="data-item">
                  <div className="data-label">2023</div>
                  <div className="data-value">{customer.bandejas_2023}</div>
                </div>
                <div className="data-item">
                  <div className="data-label">2024</div>
                  <div className="data-value">{customer.bandejas_2024}</div>
                </div>
              </div>
            </div>

            <div className="metrics-row">
              <div className="metric-box">
                <div className="metric-label">2025</div>
                <div className="metric-value">{customer.bandejas_2025}</div>
              </div>
            </div>

            <div className="card-footer">
              <div className="footer-item">
                <span className="footer-label">Caída</span>
                <span className="footer-value caida">{customer.porcentaje_caida.toFixed(2)}%</span>
              </div>
              <div className="footer-item">
                <span className={`risk-badge risk-${customer.clasificacion_riesgo.toLowerCase()}`}>
                  {customer.clasificacion_riesgo}
                </span>
              </div>
            </div>

            {customer.etapas && customer.etapas.length > 0 && (
              <>
                <button className="tasks-toggle" onClick={() => toggleCard(customer.codigo_cliente)}>
                  <div className="toggle-content">
                    <MessageSquare size={16} />
                    <span>Seguimiento Comercial ({customer.etapas.length} etapas)</span>
                  </div>
                  {expandedCards[customer.codigo_cliente] ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                </button>

                {expandedCards[customer.codigo_cliente] && (
                  <div className="tasks-section">
                    <div className="tasks-header">
                      <Target size={16} />
                      Flujo de Inteligencia Comercial
                    </div>
                    {customer.etapas.map((etapa, etapaIndex) => {
                      const currentStageData = getStageData(customer.codigo_cliente, etapa.id, etapa)
                      const isLocked =
                        etapaIndex > 0 &&
                        customer.etapas &&
                        customer.etapas.length > 0 &&
                        !isFirstStageCompleted(customer.codigo_cliente, customer.etapas[0].id, customer.etapas[0])
                      const isEditing = currentStageData.isEditing

                      return (
                        <div key={etapa.id} className={`stage-item ${isLocked ? "stage-locked" : ""}`}>
                          <div className="stage-header">
                            <div className="stage-title">
                              {etapa.tipo === "Indirecto" ? (
                                <Send className="stage-icon-indirecto" size={18} />
                              ) : (
                                <Target className="stage-icon-directo" size={18} />
                              )}
                              {etapa.nombre}
                            </div>
                            {isLocked && (
                              <div className="stage-lock">
                                <Lock size={12} />
                                Bloqueada
                              </div>
                            )}
                          </div>

                          {etapa.tipo === "Indirecto" ? (
                            <>
                              <div className="stage-checkboxes">
                                <div className="checkbox-group-label">Tipo de Contacto</div>
                                <div className="checkbox-group">
                                  <label className="checkbox-item">
                                    <input
                                      type="checkbox"
                                      checked={currentStageData.emailEnviado}
                                      onChange={() =>
                                        handleCheckboxChange(customer.codigo_cliente, etapa.id, "emailEnviado", etapa, customer.id || customer.codigo_cliente)
                                      }
                                      disabled={!isEditing}
                                    />
                                    <span className="checkbox-label">
                                      <Mail size={14} />
                                      Email
                                    </span>
                                  </label>
                                  <label className="checkbox-item">
                                    <input
                                      type="checkbox"
                                      checked={currentStageData.telefonoEnviado}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          customer.codigo_cliente,
                                          etapa.id,
                                          "telefonoEnviado",
                                          etapa,
                                        )
                                      }
                                      disabled={!isEditing}
                                    />
                                    <span className="checkbox-label">
                                      <Phone size={14} />
                                      Teléfono
                                    </span>
                                  </label>
                                </div>
                              </div>

                              <div className="stage-checkboxes">
                                <div className="checkbox-group-label">Contenido Enviado</div>
                                <div className="checkbox-group">
                                  <label className="checkbox-item">
                                    <input
                                      type="checkbox"
                                      checked={currentStageData.calidadEnviada}
                                      onChange={() =>
                                        handleCheckboxChange(customer.codigo_cliente, etapa.id, "calidadEnviada", etapa)
                                      }
                                      disabled={!isEditing}
                                    />
                                    <span className="checkbox-label">
                                      <Award size={14} />
                                      Calidad
                                    </span>
                                  </label>
                                  <label className="checkbox-item">
                                    <input
                                      type="checkbox"
                                      checked={currentStageData.certificacionesEnviadas}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          customer.codigo_cliente,
                                          etapa.id,
                                          "certificacionesEnviadas",
                                          etapa,
                                          customer.id || customer.codigo_cliente,
                                        )
                                      }
                                      disabled={!isEditing}
                                    />
                                    <span className="checkbox-label">
                                      <FileText size={14} />
                                      Certificaciones
                                    </span>
                                  </label>
                                  <label className="checkbox-item">
                                    <input
                                      type="checkbox"
                                      checked={currentStageData.avancesEnviados}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          customer.codigo_cliente,
                                          etapa.id,
                                          "avancesEnviados",
                                          etapa,
                                          customer.id || customer.codigo_cliente,
                                        )
                                      }
                                      disabled={!isEditing}
                                    />
                                    <span className="checkbox-label">
                                      <TrendingUp size={14} />
                                      Avances
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="stage-checkboxes">
                                <div className="checkbox-group-label">Método de Contacto</div>
                                <div className="checkbox-group">
                                  <label className="checkbox-item">
                                    <input
                                      type="checkbox"
                                      checked={currentStageData.telefonoEnviado}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          customer.codigo_cliente,
                                          etapa.id,
                                          "telefonoEnviado",
                                          etapa,
                                          customer.id || customer.codigo_cliente,
                                        )
                                      }
                                      disabled={!isEditing}
                                    />
                                    <span className="checkbox-label">
                                      <Phone size={14} />
                                      Teléfono
                                    </span>
                                  </label>
                                  <label className="checkbox-item">
                                    <input
                                      type="checkbox"
                                      checked={currentStageData.whatsappEnviado}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          customer.codigo_cliente,
                                          etapa.id,
                                          "whatsappEnviado",
                                          etapa,
                                          customer.id || customer.codigo_cliente,
                                        )
                                      }
                                      disabled={!isEditing}
                                    />
                                    <span className="checkbox-label">
                                      <MessageSquare size={14} />
                                      WhatsApp
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </>
                          )}

                          <div className="stage-date">
                            <span className="date-label">Realizado:</span>
                            <input
                              type="date"
                              className="date-input"
                              value={currentStageData.fechaRealizado || ""}
                              onChange={(e) =>
                                handleInputChangeWithSave(
                                  customer.codigo_cliente,
                                  etapa.id,
                                  "fechaRealizado",
                                  e.target.value,
                                  etapa,
                                  customer.id || customer.codigo_cliente,
                                )
                              }
                              disabled={!isEditing}
                            />
                          </div>

                          <div className="stage-description-wrapper">
                            <div className="description-label">Descripción del Seguimiento</div>
                            <textarea
                              className="stage-description"
                              value={currentStageData.descripcion || ""}
                              onChange={(e) =>
                                handleInputChangeWithSave(
                                  customer.codigo_cliente,
                                  etapa.id,
                                  "descripcion",
                                  e.target.value,
                                  etapa,
                                  customer.id || customer.codigo_cliente,
                                )
                              }
                              placeholder="Escribe aquí los detalles del contacto, respuestas del cliente, próximos pasos..."
                              disabled={!isEditing}
                            />
                            {isEditing && (
                              <div className="stage-user-input">
                                <label className="user-input-label">
                                  <User size={14} />
                                  Usuario:
                                </label>
                                <input
                                  type="text"
                                  className="user-input"
                                  value={currentStageData.usuario || getUserName()}
                                  onChange={(e) =>
                                    handleInputChangeWithSave(
                                      customer.codigo_cliente,
                                      etapa.id,
                                      "usuario",
                                      e.target.value,
                                      etapa,
                                      customer.id || customer.codigo_cliente,
                                    )
                                  }
                                  placeholder={getUserName() || "Nombre del usuario"}
                                />
                              </div>
                            )}
                          </div>

                          <div className="stage-actions">
                            {isEditing ? (
                              <button
                                className="btn btn-save"
                                onClick={() => toggleEditModeWithSave(customer.codigo_cliente, etapa.id, etapa, customer.id || customer.codigo_cliente)}
                              >
                                <Save size={16} />
                                Guardar
                              </button>
                            ) : (
                              <button
                                className="btn btn-edit"
                                onClick={() => toggleEditMode(customer.codigo_cliente, etapa.id, etapa)}
                              >
                                <Edit3 size={16} />
                                Modificar
                              </button>
                            )}
                          </div>

                          {currentStageData.retornoDetectado && (
                            <div className="retorno-badge">
                              <CheckCircle2 size={14} />
                              Retorno detectado
                            </div>
                          )}
                        </div>
                      )
                    })}
                  </div>
                )}
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
